@if (icon) {
  <mat-icon [rxapIcon]="icon"></mat-icon>
}
<ng-content></ng-content>
